import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export const APP_VERSION = __APP_VERSION__
export const RELEASE_ID = __GIT_SHA__.substring(0, 10)

/** Small muted build label, taken from package.json and the Git revision at build time. */
export function AppVersion({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <span className={cn('flex flex-col gap-1 text-xs text-muted-foreground tabular-nums', className)}>
      <span>{t('common.appVersion', { version: APP_VERSION })}</span>
      <span>{t('common.releaseId', { releaseId: RELEASE_ID })}</span>
    </span>
  )
}
